import { formatDate, parseISO } from 'date-fns';
import React, { FunctionComponent, ReactNode } from 'react';

import './styles';
import { Pill } from '../../../shared/Pill';
import { MyAccountActivityGiftIcon } from '../../../shared/Gift';
import { useTranslations } from '../../../../hooks/useTranslationsHelper';
import { walletTypeNames } from '../consts';

type MyAccountActivityPanelProps = {
  /**
   * The activity title.
   */
  title?: string;

  /**
   * The stake amount.
   */
  stake?: number;
  /**

  /**
   * The activity status.
   */
  status?: string;

  /**
   * The activity amount.
   */
  amount?: number;

  /**
   * A ReactNode representing the activity icon.
   */
  ActivityIcon?: ReactNode;

  /**
   * The transaction date.
   */
  transactionDate?: string;

  /**
   * The cash balance after the transaction.
   */
  cashBalanceAfter?: number | null | undefined;

  /**
   * The isFreeBet bets
   */
  isFreeBet?: boolean;

  /**
   * Wallet type
   */
  walletType: string;
};

export const MyAccountActivityPanel: FunctionComponent<MyAccountActivityPanelProps> = ({
  title,
  stake,
  status,
  amount,
  isFreeBet,
  ActivityIcon,
  transactionDate,
  cashBalanceAfter,
  walletType,
}) => {
  const { t } = useTranslations();
  const defaultClassName = 'my-account-activity-panel';

  const walletTypeTranslation =
    walletType === walletTypeNames.main
      ? 'my-account.cash-balance'
      : walletType === walletTypeNames.locked
        ? 'my-account.locked-balance'
        : 'my-account.bonus-balance';

  return (
    <div className={defaultClassName}>
      <div className={`${defaultClassName}__activity-header`}>
        <span className={`${defaultClassName}__icon-wrapper`}>
          <span className="my-account-activity-panel__icon">{ActivityIcon}</span>
        </span>
        <span className={`${defaultClassName}__title`} style={{ flex: 1.5 }}>
          {title}
        </span>
        <span className={`${defaultClassName}__amount`}>
          {status && (
            <Pill size="small">
              <span>{status}</span>
            </Pill>
          )}
          {isFreeBet && <MyAccountActivityGiftIcon />}
          &nbsp;
          {`£${Math.abs(Number(amount ?? stake ?? 0)).toFixed(2)}`}
        </span>
      </div>

      <div className={`${defaultClassName}__activity-details`}>
        {Number.isFinite(cashBalanceAfter) && (
          <div className={`${defaultClassName}__subheading`}>
            <div className={`${defaultClassName}__balances`}>
              <span
                className={`${defaultClassName}__balances-cash`}
              >{`${t(walletTypeTranslation)} £${Number(cashBalanceAfter ?? 0).toFixed(2)}`}</span>
            </div>
          </div>
        )}

        {transactionDate && (
          <span className={`${defaultClassName}__transaction-date`}>
            {formatDate(parseISO(transactionDate), 'dd/MM/yyyy | HH:mm')}
          </span>
        )}
      </div>
    </div>
  );
};
